import { render, staticRenderFns } from "./IconCrap.vue?vue&type=template&id=90e9c626&scoped=true"
import script from "./IconCrap.vue?vue&type=script&lang=js"
export * from "./IconCrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e9c626",
  null
  
)

export default component.exports